export default __webpack_public_path__ + "static/media/blt-logo.d7ba7fb6.png";